/** El cierre automático nunca supera las 48 horas sin actividad (el servidor aplica el mismo tope). */
export const AUTO_CLOSE_MAX_MINUTES = 48 * 60
export const AUTO_CLOSE_MIN_MINUTES = 5

export const INACTIVITY_PRESETS = [
  { label: '6 horas', minutes: 360 },
  { label: '12 horas', minutes: 720 },
  { label: '24 horas', minutes: 1440 },
  { label: '48 horas', minutes: AUTO_CLOSE_MAX_MINUTES },
] as const

/** Lo escrito en el campo, acotado entre 5 minutos y 48 horas; un valor vacío o inválido queda en el mínimo. */
export function clampInactivityMinutes(value: number): number {
  if (!Number.isFinite(value) || value < AUTO_CLOSE_MIN_MINUTES) return AUTO_CLOSE_MIN_MINUTES
  return Math.min(AUTO_CLOSE_MAX_MINUTES, Math.floor(value))
}
